import React, { useEffect, useState } from 'react';
import './ToggleButton.css'; // We'll define styles in a separate CSS file

const ToggleButton = ({ value, onBlur, setScore}) => {
  const [isChecked, setIsChecked] = useState(Boolean(value));

  useEffect(() => {
    setIsChecked(Boolean(value));
  }, [value]);

  const handleToggle = (e) => {
    e.stopPropagation();
    const next = !isChecked;
    setIsChecked(next);
    setScore(next ? 1 : 0);
  };

  return (
    <div 
      className="toggle-container" 
      onClick={handleToggle}
      tabIndex={0}
      onBlur={onBlur}
    >
      <div className={`toggle-option ${value != null && isChecked ? 'active' : ''}`}>
        <span className="checkmark">✓</span>
      </div>
      <div className={`toggle-option ${value != null && !isChecked ? 'active' : ''}`}>
        <span className="cross">✕</span>
      </div>
    </div>
  );
};

export default ToggleButton;